module.exports = __webpack_public_path__ + "img/irs.950a9fbc.jpg";